import { render, staticRenderFns } from "./RelatorioDeProdutividade.vue?vue&type=template&id=b4cc8606"
import script from "./RelatorioDeProdutividade.vue?vue&type=script&lang=js"
export * from "./RelatorioDeProdutividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports